import {Box, Grid2, Skeleton, Typography} from '@mui/material';

export const BigBoxSkeleton = () => (
  <Box
    sx={{
      height: 173,
      borderRadius: '12px',
      backgroundColor: '#28292F', // روشن‌تر شد
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: 2,
    }}>
    <Skeleton
      variant="rectangular"
      width={100}
      height={100}
      sx={{borderRadius: 2, bgcolor: '#1E1E1E'}}
    />
    <Box sx={{display: 'flex', gap: 1, my: 1}} px={1}>
      <Skeleton
        variant="rectangular"
        width={40}
        height={15}
        sx={{borderRadius: 2, bgcolor: '#1E1E1E'}}
      />
      <Skeleton
        variant="rectangular"
        width={40}
        height={15}
        sx={{borderRadius: 2, bgcolor: '#1E1E1E'}}
      />
      <Skeleton
        variant="rectangular"
        width={40}
        height={15}
        sx={{borderRadius: 2, bgcolor: '#1E1E1E'}}
      />
    </Box>
    <Skeleton
      variant="text"
      width="60%"
      height={20}
      sx={{bgcolor: '#1E1E1E'}}
    />
    <Skeleton
      variant="text"
      width="30%"
      height={16}
      sx={{bgcolor: '#1E1E1E'}}
    />
  </Box>
);

export const SmallBoxSkeleton = () => (
  <Box
    flexDirection={'column'}
    sx={{
      height: 112,
      borderRadius: '12px',
      backgroundColor: '#28292F',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: 2,
    }}>
    <Grid2 display={'flex'} size={12} alignItems={'center'}>
      <Skeleton
        variant="rectangular"
        width={60}
        height={60}
        sx={{borderRadius: 2, bgcolor: '#1E1E1E'}}
      />
      <Box ml={1}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'start',
            flexDirection: 'column',
          }}>
          <Skeleton
            variant="text"
            width={60}
            height={18}
            sx={{bgcolor: '#1E1E1E'}}
          />
          <Skeleton
            variant="text"
            width={40}
            height={18}
            sx={{mt: 1, bgcolor: '#1E1E1E'}}
          />
        </Box>
      </Box>
    </Grid2>
    <Box sx={{display: 'flex', gap: 1, mt: 1, justifyContent: 'space-between'}}>
      <Skeleton
        variant="rectangular"
        width={40}
        height={15}
        sx={{borderRadius: 2, bgcolor: '#1E1E1E'}}
      />
      <Skeleton
        variant="rectangular"
        width={40}
        height={15}
        sx={{borderRadius: 2, bgcolor: '#1E1E1E'}}
      />
      <Skeleton
        variant="rectangular"
        width={40}
        height={15}
        sx={{borderRadius: 2, bgcolor: '#1E1E1E'}}
      />
    </Box>
  </Box>
);

const MysteryBoxesSkeleton = () => (
  <Grid2 container direction="column">
    <Typography
      component="p"
      variant="caption"
      marginBottom="10px"
      fontSize="16px"
      fontFamily="'Geogrotesque Wide', sans-serif"
      fontWeight={500}
      lineHeight={1}
      letterSpacing={0}
      color="text.secondary">
      <Skeleton variant="text" width={120} height={16} />
    </Typography>

    <Grid2 container spacing={2}>
      <Grid2 size={6}>
        <BigBoxSkeleton />
        <Grid2 size={12} mt={2}>
          <Grid2 container direction="column" spacing={2}>
            <Grid2>
              <SmallBoxSkeleton />
            </Grid2>
            <Grid2>
              <SmallBoxSkeleton />
            </Grid2>
          </Grid2>
        </Grid2>
      </Grid2>

      <Grid2 size={6}>
        <Grid2 container direction="column" spacing={2}>
          <Grid2>
            <SmallBoxSkeleton />
          </Grid2>
          <Grid2>
            <SmallBoxSkeleton />
          </Grid2>
        </Grid2>
        <Grid2 size={12} mt={2}>
          <BigBoxSkeleton />
        </Grid2>
      </Grid2>
    </Grid2>
  </Grid2>
);

export default MysteryBoxesSkeleton;
